export enum RecreationalDrug {    
    Amphetamines = 1,
    Cocaine = 2,
    Heroin = 3,
    Marijuana = 4,
    Methamphetamines = 5,
    Other = 6
}